// extracted by mini-css-extract-plugin
module.exports = {"classifiedsDescription":"styles_classifiedsDescription__2tmcN","fieldLabel":"styles_fieldLabel__2CKBM"};